<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width"><b>An Garda Síochána:</b> the police service of the Republic of Ireland.</p>
<p class="subsq">Garda, or gardaí in the plural.</p>
<p class="subsq">Commonly referred to as <i>the guards </i>or <i>the gardaí.</i></p>
<p class="subsq">Direct translation: “the Guardian of the Peace.”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?647672af